module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/3@2x_7c0c8cfc7213a59afa0550a265f14a71.png";